module.exports = __webpack_public_path__ + "static/media/layer_4.8b57def8.png";